import script from "./HTMLEditor.vue?vue&type=script&lang=ts&setup=true"
export * from "./HTMLEditor.vue?vue&type=script&lang=ts&setup=true"

import "./HTMLEditor.vue?vue&type=style&index=0&id=6d1652d8&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d1652d8"]])

export default __exports__